// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13kSc","colBig":"styles_colBig__1q0ET","colSmall":"styles_colSmall__2Bthv"};